import { EXAMPLES, REGIONS, imageUrl, startUrl, MAP_VIEWS } from './pw-examples.js?v=3810152ec2e4';
import { orientedSize, money, terrainName } from './pw-configuration.js?v=3810152ec2e4';
import { priceFor } from './pw-commerce.js?v=3810152ec2e4';

// Cities page: example places by region, each one enlargeable and loadable into the configurator.
const $ = selector => document.querySelector(selector);
const el = (tag, className, text) => { const node = document.createElement(tag); if (className) node.className = className; if (text != null) node.textContent = text; return node; };
const slug = text => text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
const ZOOM_ICON = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="6.5"/><path d="M16 16l4.5 4.5M11 8v6M8 11h6"/></svg>';
const details = example => {
  const size = orientedSize(example.sizeId, example.orientation), format = example.orientation === 'landscape' ? 'Landscape' : 'Portrait';
  return {size, format, view: `${MAP_VIEWS[example.scale]} · 1:${example.scale.toLocaleString('en-US')}`, meta: `${size.label} · ${format} · ${MAP_VIEWS[example.scale]} view`};
};
function picture(example, large = false) {
  const landscape = example.orientation === 'landscape', image = el('img');
  Object.assign(image, {src: imageUrl(example), alt: `Engraved map of ${example.name}: ${example.area}`, loading: 'lazy', decoding: 'async', width: landscape ? 792 : 575, height: landscape ? 575 : 792});
  const button = el('button', large ? 'city-media city-media-large' : 'city-media');
  button.type = 'button'; button.dataset.zoom = example.id; button.setAttribute('aria-label', `Enlarge the ${example.name} map`);
  const badge = el('span', 'zoom-badge'); badge.innerHTML = ZOOM_ICON;
  button.append(image, badge);
  return button;
}
// "From" is the shop's own price (the linked Shopify product, as in the configurator), never a price written into
// this file; without one the row is left out. The local prototype has no shop and uses the demo catalogue.
const shopPrice = priceFor(globalThis.PLACE_WOOD_PRODUCT, {theme: globalThis.PLACE_WOOD_THEME === true});
// Terrain examples also name their topography scheme.
const specRows = (example, size, format, view) => {
  const price = shopPrice(size.id);
  const rows = [['Size', `${size.label} · ${size.inches}`], ['Format', format], ['Map view', view], ...(price == null ? [] : [['From', `${money(price)} USD`]])];
  if (example.terrain && example.terrain !== 'streets') rows.splice(3, 0, ['Topography', terrainName(example.terrain)]);
  return rows;
};
function specs(example) {
  const {size, format, view} = details(example), list = el('dl', 'city-specs');
  for (const [label, value] of specRows(example, size, format, view)) {
    const row = el('div'); row.append(el('dt', '', label), el('dd', '', value)); list.append(row);
  }
  return list;
}
function startLink(example, className, text) {
  const link = el('a', className, text); link.href = startUrl(example);
  const arrow = el('span', '', ' →'); arrow.setAttribute('aria-hidden', 'true'); link.append(arrow);
  return link;
}

const chapters = $('#cities-chapters'), regionNav = $('#cities-regions');
chapters.replaceChildren();
REGIONS.forEach((region, index) => {
  const places = EXAMPLES.filter(example => example.region === region), [featured, ...rest] = places, id = `region-${slug(region)}`;
  const count = `${places.length} ${places.length === 1 ? 'place' : 'places'}`;
  const jump = el('a', '', `${region} · ${places.length}`); jump.href = `#${id}`; regionNav.append(jump);
  const section = el('section', index % 2 ? 'city-chapter city-chapter-alt' : 'city-chapter'); section.id = id; section.setAttribute('aria-labelledby', `${id}-title`);
  const head = el('div', 'chapter-head'), title = el('h2', '', region); title.id = `${id}-title`;
  head.append(el('span', 'chapter-number', String(index + 1).padStart(2, '0')), title, el('span', 'chapter-count', count));
  const feature = el('article', index % 2 ? 'city-feature city-feature-flip' : 'city-feature'), copy = el('div', 'city-feature-copy');
  copy.append(el('span', 'eyebrow', 'FEATURED'), el('h3', '', featured.name), el('p', 'city-area', featured.area), specs(featured), startLink(featured, 'button button-dark', `Start with ${featured.name}`));
  feature.append(picture(featured, true), copy);
  section.append(head, feature);
  if (rest.length) {
    const grid = el('ul', 'city-grid');
    for (const example of rest) {
      const card = el('li', 'city-card');
      card.append(picture(example), el('h3', '', example.name), el('p', 'city-meta', details(example).meta), startLink(example, 'city-start', 'Start here'));
      grid.append(card);
    }
    section.append(grid);
  }
  chapters.append(section);
});

// Enlarged map: zoom with buttons, wheel, double-click or pinch; drag to explore; swipe between cities when not zoomed.
const dialog = $('#city-zoom'), stage = $('#zoom-stage'), image = $('#zoom-image');
const MAX_ZOOM = 4;
let current = 0, zoom = 1, panX = 0, panY = 0, pinch = null, drag = null, lastTap = 0, pointerType = 'mouse';
const pointers = new Map();
function bounds() {
  const box = stage.getBoundingClientRect(), fitW = image.offsetWidth, fitH = image.offsetHeight;
  return {x: Math.max(0, (fitW * zoom - box.width) / 2 + 24), y: Math.max(0, (fitH * zoom - box.height) / 2 + 24), box};
}
function apply() {
  const {x, y} = bounds();
  panX = Math.max(-x, Math.min(x, panX)); panY = Math.max(-y, Math.min(y, panY));
  image.style.transform = `translate(${panX}px, ${panY}px) scale(${zoom})`;
  stage.classList.toggle('is-zoomed', zoom > 1);
  $('#zoom-level').textContent = `${Math.round(zoom * 100)}%`;
  dialog.querySelector('[data-zoom-step="-1"]').disabled = zoom <= 1;
  dialog.querySelector('[data-zoom-step="1"]').disabled = zoom >= MAX_ZOOM;
}
// Keeps the point under the cursor or fingers in place while zooming.
function zoomTo(next, clientX, clientY) {
  next = Math.min(MAX_ZOOM, Math.max(1, next));
  const box = stage.getBoundingClientRect();
  const px = (clientX ?? box.left + box.width / 2) - (box.left + box.width / 2), py = (clientY ?? box.top + box.height / 2) - (box.top + box.height / 2);
  panX = px - (px - panX) * (next / zoom); panY = py - (py - panY) * (next / zoom);
  zoom = next; if (zoom === 1) { panX = 0; panY = 0; }
  apply();
}
function show(index) {
  current = (index + EXAMPLES.length) % EXAMPLES.length;
  const example = EXAMPLES[current], {size, format, view} = details(example);
  zoom = 1; panX = 0; panY = 0; image.style.transform = '';
  image.src = imageUrl(example, true); image.alt = `Engraved map of ${example.name}, enlarged: ${example.area}`;
  $('#zoom-count').textContent = `${String(current + 1).padStart(2, '0')} / ${EXAMPLES.length}`;
  $('#zoom-bar-name').textContent = example.name; $('#zoom-title').textContent = example.name;
  $('#zoom-country').textContent = example.country.toUpperCase(); $('#zoom-area').textContent = example.area;
  const list = $('#zoom-specs'); list.replaceChildren();
  for (const [label, value] of specRows(example, size, format, view)) {
    const row = el('div'); row.append(el('dt', '', label), el('dd', '', value)); list.append(row);
  }
  $('#zoom-start').href = startUrl(example);
  $('#zoom-thumbs').querySelectorAll('button').forEach((button, k) => button.setAttribute('aria-pressed', String(k === current)));
  apply();
  // Neighbours load in the background so arrows and swipes feel instant.
  for (const k of [current + 1, current - 1]) new Image().src = imageUrl(EXAMPLES[(k + EXAMPLES.length) % EXAMPLES.length], true);
}
for (const [k, example] of EXAMPLES.entries()) {
  const button = el('button'), thumb = el('img');
  button.type = 'button'; button.setAttribute('aria-label', example.name); button.addEventListener('click', () => show(k));
  Object.assign(thumb, {src: imageUrl(example), alt: '', loading: 'lazy'});
  button.append(thumb); $('#zoom-thumbs').append(button);
}
chapters.addEventListener('click', event => {
  const button = event.target.closest('[data-zoom]');
  if (!button) return;
  show(EXAMPLES.findIndex(example => example.id === button.dataset.zoom));
  dialog.showModal();
  apply();
});
image.addEventListener('load', apply);
dialog.querySelector('.zoom-close').addEventListener('click', () => dialog.close());
dialog.querySelectorAll('[data-zoom-step]').forEach(button => button.addEventListener('click', () => zoomTo(zoom + Number(button.dataset.zoomStep))));
dialog.querySelectorAll('[data-zoom-nav]').forEach(button => button.addEventListener('click', () => show(current + Number(button.dataset.zoomNav))));
dialog.addEventListener('keydown', event => {
  if (event.target.closest('a, input')) return;
  if (event.key === 'ArrowRight' && zoom === 1) show(current + 1);
  else if (event.key === 'ArrowLeft' && zoom === 1) show(current - 1);
  else if (event.key === '+' || event.key === '=') zoomTo(zoom + 1);
  else if (event.key === '-') zoomTo(zoom - 1);
  else return;
  event.preventDefault();
});
dialog.addEventListener('close', () => { pointers.clear(); drag = pinch = null; });
// Touch double-taps are detected below, so browsers that also synthesise dblclick do not zoom twice.
stage.addEventListener('dblclick', event => { if (pointerType !== 'touch') zoomTo(zoom > 1 ? 1 : 2.5, event.clientX, event.clientY); });
stage.addEventListener('wheel', event => { event.preventDefault(); zoomTo(zoom * Math.exp(-event.deltaY * 0.002), event.clientX, event.clientY); }, {passive: false});
stage.addEventListener('pointerdown', event => {
  if (event.target.closest('button')) return;
  pointerType = event.pointerType;
  stage.setPointerCapture(event.pointerId);
  pointers.set(event.pointerId, {x: event.clientX, y: event.clientY});
  if (pointers.size === 2) {
    const [a, b] = [...pointers.values()];
    pinch = {distance: Math.hypot(a.x - b.x, a.y - b.y), zoom}; drag = null;
  } else drag = {x: event.clientX, y: event.clientY, panX, panY, moved: false, time: Date.now()};
});
stage.addEventListener('pointermove', event => {
  if (!pointers.has(event.pointerId)) return;
  pointers.set(event.pointerId, {x: event.clientX, y: event.clientY});
  if (pinch && pointers.size === 2) {
    const [a, b] = [...pointers.values()];
    zoomTo(pinch.zoom * Math.hypot(a.x - b.x, a.y - b.y) / pinch.distance, (a.x + b.x) / 2, (a.y + b.y) / 2);
  } else if (drag) {
    const dx = event.clientX - drag.x, dy = event.clientY - drag.y;
    if (Math.abs(dx) + Math.abs(dy) > 5) drag.moved = true;
    if (zoom > 1) { panX = drag.panX + dx; panY = drag.panY + dy; apply(); }
  }
});
for (const type of ['pointerup', 'pointercancel']) stage.addEventListener(type, event => {
  pointers.delete(event.pointerId);
  if (pointers.size < 2) pinch = null;
  if (drag && type === 'pointerup' && zoom === 1 && drag.moved) {
    const dx = event.clientX - drag.x;
    if (Math.abs(dx) > 60 && Date.now() - drag.time < 700) show(current + (dx < 0 ? 1 : -1));
  } else if (drag && type === 'pointerup' && !drag.moved && event.pointerType === 'touch') {
    if (Date.now() - lastTap < 320) { lastTap = 0; zoomTo(zoom > 1 ? 1 : 2.5, event.clientX, event.clientY); } else lastTap = Date.now();
  }
  if (!pointers.size) drag = null;
});
new ResizeObserver(() => { if (dialog.open) apply(); }).observe(stage);
